import React, { useState, useEffect } from 'react';
import { Route, Routes, BrowserRouter, Navigate } from 'react-router-dom';
import routes from './Routes.js';
import Home from './components/Home/Home';
import About from './components/About/About';
import SignupPage from './components/Login/SignupPage.js';
import ConfirmSignupPage from './components/Login/ConfirmSignupPage.js';
import ChatBot from './components/ChatBot/ChatBot';
import { filterRoutes } from './utils/routeStatus';

export const switchRoutes = (userRole) => (
  <React.Fragment>
    {filterRoutes(routes.mainRoutes, userRole).map((route, index) => {
      return route.component ? (
        <Route
          path={route.path}
          name={route.name}
          element={<route.component />}
          key={index}
        />
      ) : (
        <React.Fragment></React.Fragment>
      );
    })}
  </React.Fragment>
);

// Component to handle role-based default routing
const RoleBasedRedirect = () => {
  const userRole = localStorage.getItem("userRole");
  
  // Define default paths for each role
  const getDefaultPath = (role) => {
    switch (role) {
      case 'Mentor':
        return '/Dashboard'; // Mentors start at Dashboard
      case 'Client':
        return '/Dashboard'; // Clients start at Dashboard
      case 'User':
        return '/AssessmentIndex'; // Users start at Assessments
      default:
        return '/Dashboard'; // Fallback to Dashboard
    }
  };

  return <Navigate to={getDefaultPath(userRole)} replace />;
};

const App = () => {
  const [, setRefresh] = useState(false);
  const currentUser = localStorage.getItem("user");
  const user = JSON.parse(JSON.stringify(currentUser));
  const userRole = localStorage.getItem("userRole");
  
  const handleRefresh = () => {
    setRefresh(true);
  }

  return (
    <div>
      <BrowserRouter>
        <Routes>
          {/* Public route for Signup */}
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/ConfirmSignupPage" element={<ConfirmSignupPage />} />

          <Route
            path="/"
            element={user ? <Home /> : <About refresh={handleRefresh} />}>
            
            {/* Role-based default redirect */}
            <Route index element={user ? <RoleBasedRedirect /> : null} />
            
            {switchRoutes(userRole)}
          </Route>
        </Routes>
        
        {/* Global ChatBot - shows on all pages when user is logged in */}
        {/* {user && <ChatBot />} */}
      </BrowserRouter>
    </div>
  );
};

export default App;